import React from "react";
import { FTFlex } from "../flex";
import FormatTags from "../format-tags";
import styles from "./index.module.scss";
import { UploadSvg } from "@/assets/icons";
// import { useTransition } from "react";
import { useTranslation } from "react-i18next";
import { DragEventHandler } from "react";
import clsx from "clsx";
const tags = ["JPG", "JPEG", "PNG", "HEIC", "HEIF", "WEBP"];

interface PropsType {
  onClick?: () => void;
  onChoose?: (file: File) => void;
}
export default function CommonUploadSection(props: PropsType) {
  const [isDrag, setIsDrag] = React.useState(false);
  const { t } = useTranslation();
  const handleClick = () => {
    props.onClick?.();
  };
  const handleDrop: React.DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      props.onChoose?.(file);
    }
  };
  const handleDragOver: DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDrag(true);
  };
  const handleDragLeave: DragEventHandler<HTMLDivElement> = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDrag(false);
  };

  return (
    <div
      className={clsx(styles.wrapper, isDrag && styles.drag)}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      <FTFlex
        className={styles.content}
        direction="column"
        align="center"
        justify="center"
        gap={24}
      >
        <p className={styles.click_drop}>{t("upload_title")}</p>
        <button className={styles.btn} onClick={handleClick}>
          <i>
            <UploadSvg />
          </i>
          <span>{t("upload_btn")}</span>
        </button>
        <FTFlex className={styles.format} gap={8} align="center">
          <span>{t("upload_format")}</span>
          <FormatTags tags={tags.map((item) => t(`upload_format_${item}`))} />
        </FTFlex>
      </FTFlex>
    </div>
  );
}
